import { disputeDeflectionViewSchema_ } from "@redotech/redo-dispute-common/dispute-deflection-view-definition";
import {
  disputeDeflectionOutcome,
  disputeDeflectionSortableColumns,
} from "@redotech/redo-dispute-db-schema/dispute-deflection-definition";
import { SortDirectionSchema } from "@redotech/redo-views-common/table";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

// The deflection view plus the merchant identity, resolved per-batch in the
// handler.
const reclaimDeflectionRowSchema_ = disputeDeflectionViewSchema_.extend({
  teamName: z.string().nullish(),
  teamId: z.string().nullish(),
});

export const reclaimDeflectionRowSchema: z.ZodType<ReclaimDeflectionRow> =
  reclaimDeflectionRowSchema_;

export interface ReclaimDeflectionRow
  extends z.infer<typeof reclaimDeflectionRowSchema_> {}

// Cross-account list of RESOLVE (deflection) requests for the admin Resolve tab.
// Mirrors getReclaimAlerts.
export const getReclaimDeflections = unaryRpc({
  name: "getReclaimDeflections" as const,
  input: z.object({
    offset: z.number().int().min(0).optional(),
    limit: z.number().int().min(1).max(1000).optional(),
    outcomes: z.array(z.enum(disputeDeflectionOutcome)).optional(),
    sort: z
      .object({
        sortBy: z.enum(disputeDeflectionSortableColumns),
        sortDirection: SortDirectionSchema,
      })
      .optional(),
  }),
  output: z.object({ deflections: z.array(reclaimDeflectionRowSchema) }),
});
